if (!customElements.get('back-in-stock-inline')) {
  class BackInStockInline extends HTMLElement {
    static STORAGE_KEY = 'backInStockEmail';

    connectedCallback() {
      this.formPanel = this.querySelector('[data-back-in-stock-form]');
      this.successPanel = this.querySelector('[data-back-in-stock-success]');
      this.changeButton = this.querySelector('[data-back-in-stock-change]');
      this.emailInput = this.querySelector('[data-back-in-stock-email-input]');
      this.successEmailEl = this.querySelector('[data-back-in-stock-success-email]');
      this.sectionId = this.dataset.sectionId;
      this.container = document.getElementById(`BackInStockInline-${this.sectionId}`);

      this.changeButton?.addEventListener('click', this.handleChange.bind(this));
      this.emailInput?.addEventListener('input', this.handleEmailInput.bind(this));
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));

      if (new URLSearchParams(window.location.search).has('contact_posted')) {
        this.container?.setAttribute('data-notify-posted', 'true');
      }

      if (this.emailInput?.value) {
        this.setStoredEmail(this.emailInput.value);
      }

      this.syncPostedVisibility();
    }

    disconnectedCallback() {
      this.variantChangeUnsubscriber?.();
    }

    getStoredEmail() {
      return sessionStorage.getItem(BackInStockInline.STORAGE_KEY) ?? '';
    }

    setStoredEmail(email) {
      sessionStorage.setItem(BackInStockInline.STORAGE_KEY, email);
    }

    clearStoredEmail() {
      sessionStorage.removeItem(BackInStockInline.STORAGE_KEY);
    }

    getSelectedVariant() {
      const variantJson = document
        .querySelector(`#variant-selects-${this.sectionId} [data-selected-variant]`)
        ?.textContent;

      if (!variantJson) return null;

      try {
        return JSON.parse(variantJson);
      } catch (error) {
        return null;
      }
    }

    handleEmailInput(event) {
      const email = event.target.value;
      this.setStoredEmail(email);

      if (!this.successPanel?.classList.contains('hidden')) {
        this.updateSuccessEmail(email);
      }
    }

    updateSuccessEmail(email) {
      if (this.successEmailEl) {
        this.successEmailEl.textContent = email;
      }
    }

    syncPostedVisibility(variant = this.getSelectedVariant()) {
      if (!this.isPosted()) return;
      console.log(this.isPosted());

      if (!variant) {
        if (!document.getElementById(`variant-selects-${this.sectionId}`)) {
          this.container?.classList.remove('hidden');
          this.showSuccess();
        }
        return;
      }

      if (!variant.available) {
        this.container?.classList.remove('hidden');
        this.showSuccess();
      } else {
        this.container?.classList.add('hidden');
      }
    }

    isPosted() {
      if (this.container?.hasAttribute('data-notify-posted')) {
        return true;
      }

      return new URLSearchParams(window.location.search).has('contact_posted');
    }

    handleVariantChange({ data: { sectionId, variant } }) {
      if (!this.isPosted()) return;

      const eventSectionId = sectionId.replace(/^template--\d+__/, '');
      const currentSectionId = this.sectionId.replace(/^template--\d+__/, '');

      if (eventSectionId !== currentSectionId) return;

      this.syncPostedVisibility(variant);
    }

    showSuccess() {
      this.successPanel?.classList.remove('hidden');
      this.formPanel?.classList.add('hidden');
      this.updateSuccessEmail(this.getStoredEmail());
    }

    showForm() {
      this.successPanel?.classList.add('hidden');
      this.formPanel?.classList.remove('hidden');

      const variantInput = this.querySelector('[data-back-in-stock-variant-input]');
      const variant = document
        .querySelector(`#variant-selects-${this.sectionId} [data-selected-variant]`)
        ?.textContent;

      if (!variantInput || !variant) return;

      try {
        variantInput.value = JSON.parse(variant).title ?? '';
      } catch (error) {
        console.error(error);
      }
    }

    handleChange() {
      this.container?.removeAttribute('data-notify-posted');
      this.clearStoredEmail();

      const url = new URL(window.location.href);
      url.searchParams.delete('contact_posted');
      url.hash = '';
      window.history.replaceState({}, '', `${url.pathname}${url.search}`);

      this.showForm();
    }
  }

  customElements.define('back-in-stock-inline', BackInStockInline);
}
